{
  "name": "@ns/invite-company-employees",
  "version": "1.0.0",
  "description": "Join the company that invited you to nodeStream.",
  "inputs": {},
  "outcomes": {
    "complete": {}
  }
}
